import { TSelectOption } from '@interfaces/components/componentTypes';

export enum EKpiAlertTab {
	rules = 'rules',
	alerts = 'alerts',
}

export const tabs = [
	{
		title: 'Rules',
		value: EKpiAlertTab.rules,
		iconName: '',
		isVisible: true,
	},
	{
		title: 'Alerts',
		value: EKpiAlertTab.alerts,
		iconName: '',
		isVisible: true,
	},
];

export const SeverityOptions: TSelectOption<string>[] = [
	{
		label: 'Critical',
		value: 'CRITICAL',
	},
	{
		value: 'ERROR',
		label: 'Error',
	},
	{
		label: 'Warning',
		value: 'WARNING',
	},
	{
		label: 'Informational',
		value: 'INFORMATIONAL',
	},
];

export const StatusOptions: TSelectOption<string>[] = [
	{
		label: 'Active',
		value: 'ACTIVE',
	},
	{
		label: 'Inactive',
		value: 'INACTIVE',
	},
];
